module.exports = "<p>This is not the page you're looking for.</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page-not-found/page-not-found.component.html
// module id = ./src/app/components/page-not-found/page-not-found.component.html
// module chunks = main